import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, TableCell, TableHead, TableRow, Dialog, DialogContent, DialogActions, TableBody, Box, DialogTitle, Stack, Typography, TableContainer} from '@mui/material';
import { Table, Paper } from '@mui/material';
import { usePost, usePostFile } from '../../../apis/ApiRequests';
import { fileURL } from '../../../apis/ApiConfig';
import Header from '../../../components/uiParts/hygiene/Header';
import Frame from '../../../components/uiParts/Frame';
import { useAuth } from '../../../contexts/AuthContext';
import { dateToString } from '../../../utils/Library';
import '../../../App.css';
import CustomSnackBar from '../../../components/alert/CustomSnackBar';
import CheckStatusButtons from '../../../components/input/CheckStatusButtons';
import { generateDailyReportPDF } from '../exportReportPdf';
import TitleBar from '../../../components/uiParts/TitleBar';
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from '@mui/icons-material/Print';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ChecklistIcon from '@mui/icons-material/Checklist';
import GetAppIcon from '@mui/icons-material/GetApp';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CustomOutlinedInput from '../../../components/input/CustomOutlinedInput';
import BackspaceIcon from '@mui/icons-material/Backspace';
import DoneIcon from '@mui/icons-material/Done';
import ReaOnlyOutlinedInput from '../../../components/input/ReaOnlyOutlinedInput';
import CustomConfirm from '../../../components/confirm/CustomConfirm';
import CustomTextarea from '../../../components/input/CustomTextarea';

// HACCPマスタ 冷蔵庫コード
const REFRIGERATOR_CODES =[33];
// HACCPマスタ 冷凍庫コード
const FREEZER_CODES =[34,35];
// HACCPマスタ 水質センサーコード
const SENSOR_CODES =[36,37,38,39];

// 冷蔵庫の下限・上限
const REFRIGERATOR_MIN_TEMPERATURE = 0;
const REFRIGERATOR_MAX_TEMPERATURE = 5;

// 冷凍庫の上限
const FREEZER_MAX_TEMPERATURE = -18;

const HygieneCheckList = () => {

    const { authInfo }   = useAuth();
    const rowRefs = useRef({});

    //===============================================
    // initialize
    //===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId;
    const userName       = authInfo.userName
	const authority      = Number(authInfo.authority);
    const today          = authInfo.targetDate;
    
    
    const search    = useLocation().search;
    const query     = new URLSearchParams(search);
    const hygieneIdOrg = query.get('hygieneId');

    //-----------------------------------------------
    // initialize - useState
    //-----------------------------------------------
    const [contentsHeight, setContentsHeight] = useState(window.innerHeight -260);
    const [hygieneId, setHygieneId] = useState(hygieneIdOrg);
    const [targetSeqNo, setTargetSeqNo] = useState(1);
    const [entryDate, setEntryDate] = useState(today);
    const [targetDataList, setTargetDataList] = useState([]);
    const [haccpList, setHaccpList] = useState([]);
    const [openDialogCheclList, setOpenDialogCheclList] = useState(false);
	const [openDialogDatail, setOpenDialogDatail] = useState(false);
    const [openDialogImageFile, setOpenDialogImageFile] = useState(false);
    const [requireMessage, setRequireMessage] = useState('');
    const [isDispDeleteInDatail, setIsDispDeleteInDatail ] = useState(false);
    const [isFromCheckListInput, setIsFromCheckListInput ] = useState(false);

    // Hygieneデータ
    const [ hygieneData, setHygieneData ] = useState({
        entryDate : '',
        registerUserId : '',
        registerUser : '',
        updateUserId : '',
        updateDatetimeDsp : '',
        updateUser : '',
        approvedUserId : '',
        approvedUser : '',
        hygieneStatus : '',
    });
    // 
    // 選択中のデータ
    const [ targetData, setTargetData ] = useState({
        code : '',
        name : '',
        text : '',
        seq  : '',
        checkStatus : '',
        textx1 : '',
        textx2 : '',
        textx3 : '',
        textx4 : '',
        textx5 : '',
        imageFilePathx1 : '',
        imageFilePathx2 : '',
        imageFilePathx3 : '',
        imageFilePathx4 : '',
        imageFilePathx5 : '',
        updateDatetimeDsp : '',
        updateUser : '',
    })
    // UI Message
    const [messageState, setMessageState] = useState({
        snackBarTrue: false,
        snackBarFalse: false,
        confirm: false,
        require: false,
        confirm_detail: false,
        confirm_apploved: false,
        resultSelectionAlert :false,
        resultSelectionAlertInDetail :false,
    });

    //===============================================
    // API
    //===============================================
    //-----------------------------------------------
    // API - getData / HygieneList
    //-----------------------------------------------
    const { response: getData_res, post: getData_post } = usePost();
    const getData = async () => {
        const postData = {
            'className'    : 'mch.models.table.HygieneList',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'entryDate'    : entryDate,
            'hygieneId'    : hygieneId,
        }
        await getData_post(postData);
    }
    //-----------------------------------------------
    // API - setData / HygieneList
    //-----------------------------------------------
    const { response : setData_res, loading : setData_Loading, post:setData_post } = usePost();
    const setData = async (historyActiveFlag, dataList) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'         : 'mch.models.table.HygieneList',
            'methodName'        : 'entryData',
            'facilityCode'      : facilityCode,
            'userId'            : userId,
            'historyActiveFlag' : historyActiveFlag,
            'entryDate'         : numericDate,
            'hygieneId'         : hygieneId,
            'approvedUserId'    : 0,
            'targetDataList'    : dataList,
        }
        await setData_post(postData);
    };
    //-----------------------------------------------
    // API - deleteData / HygieneList
    //-----------------------------------------------
    const { response : deleteData_res, post:deleteData_post } = usePost();
    const deleteData = async (activeFlag) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'      : 'mch.models.table.HygieneList',
            'methodName'     : 'deleteData',
            'facilityCode'   : facilityCode,
            'userId'         : userId,
            'activeFlag'     : activeFlag,
            'entryDate'      : numericDate,
            'hygieneId'      : hygieneId,
        }
        await deleteData_post(postData);
    };
    //-----------------------------------------------
    // API - updateHygieneList / HygieneList
    //-----------------------------------------------
    const { response: updateHygieneList_res, post: updateHygieneList_post } = usePost();
    const updateHygieneList = async (hygieneStatus) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'     : 'mch.models.table.HygieneList',
            'methodName'    : 'updateHygieneList',
            'facilityCode'  : facilityCode,
            'userId'        : userId,
            'entryDate'     : numericDate,
            'hygieneId'     : hygieneId,
            'hygieneStatus' : hygieneStatus,
        }
        await updateHygieneList_post(postData);
    }
    //-----------------------------------------------
    // API - searchData / HygieneList
    //-----------------------------------------------
    const { response: searchEntryDateHygieneList_res, post: searchEntryDateHygieneList_post } = usePost();
    const searchEntryDateHygieneList = async () => {
        const startDate = dateToString(entryDate);
        const endDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.table.HygieneList',
            'methodName'   : 'searchData',
            'facilityCode'   : facilityCode,
            'userId'       : userId,
            'startDate'   : startDate,
            'endDate'   : endDate,
        }
        await searchEntryDateHygieneList_post(postData);
    }
    //-----------------------------------------------
    // API - setData / HygieneHistory
    //-----------------------------------------------
    const { response : searchDataHistory_res, post:DataHistory_post } = usePost();
    const searchDataHistory = async () => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.table.HygieneHistory',
            'methodName'   : 'searchDataByTargetDate',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await DataHistory_post(postData);
    };
    //-----------------------------------------------
    // API - searchData / HygieneHistory
    //-----------------------------------------------
    const { response : searchDataByRecent_res, loading : searchDataByRecent_Loading, post:searchDataByRecent_post } = usePost();
    const searchDataByRecent = async (targetData) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'       : 'mch.models.table.HygieneHistory',
            'methodName'      : 'searchDataByRecent',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'hygieneId'       : hygieneId,
            'entryDate'       : numericDate,
        }
        await searchDataByRecent_post(postData);
    };
    //-----------------------------------------------
    // API - searchData / masta.Haccp
    //-----------------------------------------------
    const { response : searchData_haccp_res, loading : searchData_haccp_Loading, post:searchData_haccp_post } = usePost();
    const searchData_haccp = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Haccp',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
        }
        await searchData_haccp_post(postData);
    };
    //-----------------------------------------------
    // API - searchData / masta_User
    //-----------------------------------------------
    const { response : searchData_res, post:searchData_post } = usePost();
    const searchUserData = async () => {
        const postData = {
            'className'    : 'mch.models.masta.User',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'keyword1'     : "",
        }
        await searchData_post(postData);
    };
    //-----------------------------------------------
	// API - searchData / Sensor
	//-----------------------------------------------
	const { response : judgeWaterQualityData_res, post:judgeWaterQualityData_post } = usePost();
	const judgeWaterQualityData = async (lineNo) => {
		const numericDate = dateToString(today);
		const postData = {
			'className'    : 'mch.models.table.Sensor',
			'methodName'   : 'getDataByRecent',
			'facilityCode' : facilityCode,
			'userId'       : userId,
			'entryDate'    : numericDate,
            'lineNo'       : lineNo,
		}
		await judgeWaterQualityData_post(postData);
	};
	//-----------------------------------------------
    // API - ファイルアップロード
	//-----------------------------------------------
	const { postFile, loading, error, response:postFile_Res } = usePostFile();
    
	//===============================================
	// useEffect
	//===============================================
    //-----------------------------------------------
    // useEffect - ロード時の設定
    //-----------------------------------------------
    useEffect(() => {

        getData();
        searchUserData();
        searchDataByRecent();
        searchData_haccp();
        searchDataHistory();

        const handleResize = () => {
          setContentsHeight(window.innerHeight - 260);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);
	//-----------------------------------------------
    // useEffect - hygieneIdの変更
	//-----------------------------------------------
    useEffect(() => {
        getData();
    }, [hygieneId]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchDataByRecent / HygieneHistory)
	//-----------------------------------------------
    useEffect(() => {
        setTargetDataList([]);
        if (searchDataByRecent_res) {
            setTargetSeqNo(searchDataByRecent_res.Seq);
            setTargetDataList(searchDataByRecent_res.Data);
        }
    }, [searchDataByRecent_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / HygieneList)
	//-----------------------------------------------
    useEffect(() => {
        setHygieneData({});
        if (getData_res) {
            setHygieneData({
                ...getData_res
            });
        }
    }, [getData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / HygieneList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            onSuccess();
            refreshData(setData_res.hygieneId);
        }
    }, [setData_res]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(setData / HygieneList)
	//-----------------------------------------------
    useEffect(() => {
        if (deleteData_res) {
            onSuccess();
            refreshData(null);
        }
    }, [deleteData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(updateHygieneList / HygieneList)
	//-----------------------------------------------
    useEffect(() => {
        if (updateHygieneList_res) {
            searchEntryDateHygieneList();
            setMessageInfo('confirm_apploved', false);
            setMessageInfo('snackBarTrue', true);
        }
    }, [updateHygieneList_res]);
    //-----------------------------------------------
    // useEffect -hygieneIdの取得
    //-----------------------------------------------
    useEffect(() => {
        if (searchEntryDateHygieneList_res) {
            setHygieneId(searchEntryDateHygieneList_res.Data[0]?.hygieneId);
        }
        getData();
    }, [searchEntryDateHygieneList_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_Haccp)
	//-----------------------------------------------
    useEffect(() => {
        setHaccpList([]);
        if (searchData_haccp_res) {
            setHaccpList(searchData_haccp_res.Data);
        }
    }, [searchData_haccp_res]);
	//-----------------------------------------------
    // useEffect - 表示中の履歴に対してHACCPマスタをマッピングする
	//-----------------------------------------------

    //-----------------------------------------------
    // useEffect - 日付変更時の初期化 + データ取得
    //-----------------------------------------------
    useEffect(() => {
        if (!entryDate) return;
        searchEntryDateHygieneList();
        searchDataHistory();

    }, [entryDate]);
    //-----------------------------------------------
    // useEffect - 画像の更新でtargetDataListに変更を反映
    //-----------------------------------------------
    useEffect(() => {
        if (!targetData?.code) return;

        setTargetDataList(prev =>
            prev.map(row =>
                String(row.code) === String(targetData.code)
                    ? {
                        ...row,
                        imageFilePathx1: targetData.imageFilePathx1,
                        imageFilePathx2: targetData.imageFilePathx2,
                        imageFilePathx3: targetData.imageFilePathx3,
                        imageFilePathx4: targetData.imageFilePathx4,
                        imageFilePathx5: targetData.imageFilePathx5,
                    }
                    : row
            )
        );
    }, [
        targetData.imageFilePathx1,
        targetData.imageFilePathx2,
        targetData.imageFilePathx3,
        targetData.imageFilePathx4,
        targetData.imageFilePathx5,
    ]);

    //-----------------------------------------------
    // useEffect - 水質データ閾値判定結果を履歴に反映
    //-----------------------------------------------
    useEffect(() => {
        if (judgeWaterQualityData_res !== null) {
            if (judgeWaterQualityData_res.status !== ""){

                const dataFromTargetDataList = targetDataList.find(item => String(item.code) === String(SENSOR_CODES[judgeWaterQualityData_res.lineNo-1]));

                let targetRow = {...dataFromTargetDataList, 
                                    updateUserId: "",
                                    updateDatetime: "",
                                    textx1 : judgeWaterQualityData_res.text,
                                    checkStatus : judgeWaterQualityData_res.status,
                                    imageFilePathx1 : "",
                                    imageFilePathx2 : "",
                                    imageFilePathx3 : "",
                                    imageFilePathx4 : "",
                                    imageFilePathx5 : "",
                                }

                setData(1,[targetRow]);
            } else {
                setMessageInfo('snackBarFalse', true);
            }
        }
    }, [judgeWaterQualityData_res]);

    //===============================================
    // eventHandler
    //===============================================
    //-----------------------------------------------
    // eventHandler - 日付の変更
    //-----------------------------------------------
    const handleChange_entryDate = (value) => {
        setEntryDate(value);
    };
    //-----------------------------------------------
    // eventHandler - リストのスクロール（↓へ）
    //-----------------------------------------------
    const handleScrollNext = (index) => {
        const next = haccpList[index + 1];
        if (!next) return;

        const el = rowRefs.current[next.code];
        if (el) {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };
    //-----------------------------------------------
    // eventHandler - リストのスクロール（↑へ）
    //-----------------------------------------------
    const handleScrollPrev = (index) => {
        const prev = haccpList[index - 1];
        if (!prev) return;

        const el = rowRefs.current[prev.code];
        if (el) {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };
    //-----------------------------------------------
    // eventHandler - チェックボックス変更
    //-----------------------------------------------
    const handleChange_reportCheck = (item, checkStatus) => {
        if (!item) return;

        const nextStatus = item.checkStatus === checkStatus ? null : checkStatus;

        setTargetDataList(prev =>
            prev.map(row =>
                row.code === item.code
                    ? { ...row, checkStatus: nextStatus }
                    : row
            )
        );
        // チェックNGの場合は詳細ダイアログを開く
        if (nextStatus === 0) {
            handleClick_openDetail(item, nextStatus, true, false);
        }
    };
    //-----------------------------------------------
    // eventHandler - ○×変更（詳細画面）
    //-----------------------------------------------
    const handleChange_DatailScreenChangeCheckStatus = (checkStatus) => {

        const current = targetData;
        if (!current) return;

        const nextStatus = current.checkStatus === checkStatus ? null : checkStatus;
        handleChange('checkStatus', nextStatus);
    };
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        setTargetData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }));
    };
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = async (activeFlag) => {
        const registerData = targetDataList.filter(item => item.checkStatus === 0 || item.checkStatus === 1);
        // 登録時に全ての項目が未選択の場合、登録NG
        if (activeFlag === 1 ){
            if (activeFlag === 0 || registerData.length !== 0) {
                await setData(activeFlag, registerData);
            } else {
                setMessageInfo('resultSelectionAlert', true);
            }
        } else {
            await deleteData(activeFlag, activeFlag)
        }
    };
	//-----------------------------------------------
    // eventHandler - 詳細登録ボタン
	//-----------------------------------------------
    const handleClick_detailRegister = async (activeFlag) => {
        const checked = targetData.checkStatus === 1 || targetData.checkStatus === 0 ? 1 : 0;
        if (!checked) {
            setMessageInfo('resultSelectionAlertInDetail', true);
            return
        };
        if(isFromCheckListInput){
            setTargetDataList(prev =>
                prev.map(row =>
                    row.code === targetData.code
                        ? { ...row, checkStatus : targetData.checkStatus, textx1 : targetData.textx1}
                        : row
                )
            );
            setOpenDialogDatail(false);
        }else{
            await setData(activeFlag,[targetData]);
        }
    }
	//-----------------------------------------------
    // eventHandler - 承認ボタン
	//-----------------------------------------------
    const handleClick_applovedRegister = async (hygieneStatus) => {
        updateHygieneList(hygieneStatus);
    }
    //-----------------------------------------------
    // eventHandler - チェックリストダイアログを表示
    //-----------------------------------------------
    const handleClick_dialog_checkList = () => {
        searchEntryDateHygieneList();
        searchDataHistory();
        searchDataByRecent();

        setOpenDialogCheclList(true);
    }
    //-----------------------------------------------
    // eventHandler - チェックリストダイアログを表示
    //-----------------------------------------------
    const handleClick_dialog_checkList_close = () => {
        searchEntryDateHygieneList();
        searchDataHistory();
        searchDataByRecent();
        setOpenDialogCheclList(false);
    }
    //-----------------------------------------------
    // eventHandler - チェックリストダイアログから記録内容を更新
    //-----------------------------------------------
    const handleChange_textx1 = (code, value) => {
        setTargetDataList(prev =>
            prev.map(row =>
                row.code === code
                    ? { ...row, checkStatus: getStatus(row.code, value, row.checkStatus), textx1: value, }
                    : row
            )
        );
    };
    //-----------------------------------------------
    // eventHandler - 詳細入力画面から記録内容を更新
    //-----------------------------------------------
    const handleChange_DatailScreenTextx1 = (value) => {
        setTargetData({...targetData,checkStatus: getStatus(targetData.code, value, targetData.checkStatus), textx1 : value})
    };
    //-----------------------------------------------
    // eventHandler - 詳細ダイアログを表示
    //-----------------------------------------------
    function handleClick_openDetail(targetRow, checkStatus, newIsFromCheckListInput, newIsDispDeleteInDatail) {
        const userName = getUserName(targetRow?.updateUserId ?? "");
        const updateDate = targetRow?.updateDatetime;
        const updateDateMMddHHmm = (updateDate ?? "").length !== 14 ? "" :
                                    updateDate.substr(4, 2) +"/" + updateDate.substr(6, 2) + " " + updateDate.substr(8, 2) +":" + updateDate.substr(10, 2);
        
        setIsFromCheckListInput(newIsFromCheckListInput);
        setIsDispDeleteInDatail(newIsDispDeleteInDatail);
        setTargetData({
            code : targetRow?.code,
            name : targetRow?.name,
            text : targetRow?.text,
            seq  : targetRow?.seq ?? '',
            checkStatus : checkStatus,
            textx1 : targetRow?.textx1,
            textx2 : targetRow?.textx2,
            textx3 : targetRow?.textx3,
            textx4 : targetRow?.textx4,
            textx5 : targetRow?.textx5,
            imageFilePathx1 : targetRow?.imageFilePathx1,
            imageFilePathx2 : targetRow?.imageFilePathx2,
            imageFilePathx3 : targetRow?.imageFilePathx3,
            imageFilePathx4 : targetRow?.imageFilePathx4,
            imageFilePathx5 : targetRow?.imageFilePathx5,
            updateDatetimeDsp : updateDateMMddHHmm,
            updateUser : userName,
        });
        setOpenDialogDatail(true);
    }
    //-----------------------------------------------
    // eventHandler - 詳細ダイアログを表示
    //-----------------------------------------------
    function handleClick_openDetailWithoutCheck(haccpCode, newIsFromCheckListInput, targetDataFromHistry) {
        const dataFromTargetDataList = targetDataList.find(item => String(item.code) === String(haccpCode));
        
        let targetRow;
        if(newIsFromCheckListInput){
            targetRow = {...dataFromTargetDataList};
        }else if(targetDataFromHistry == null){
            targetRow = {...dataFromTargetDataList, 
                            updateUserId: "",
                            updateDatetime: "",
                            textx1 : "",
                            checkStatus : null,
                            imageFilePathx1 : "",
                            imageFilePathx2 : "",
                            imageFilePathx3 : "",
                            imageFilePathx4 : "",
                            imageFilePathx5 : "",
                        }
        }else{
            targetRow = {...targetDataFromHistry, name : dataFromTargetDataList?.name, text : dataFromTargetDataList?.text}
        }
        const checkStatus = targetRow?.checkStatus;
        const newIsDispDeleteInDatail = targetDataFromHistry != null;
        handleClick_openDetail(targetRow, checkStatus, newIsFromCheckListInput, newIsDispDeleteInDatail)
    }
    //-----------------------------------------------
    // eventHandler - 詳細ダイアログを非表示
    //-----------------------------------------------
    const handleClick_dialog_detail_close = () => {
        setOpenDialogDatail(false);
    }
	//-----------------------------------------------
    // eventHandler - 画像ファイルのダイアログ表示
	//-----------------------------------------------
    const handleClick_dialog_imageFile = (src) => {
        setOpenDialogImageFile(src);
    };
	//-----------------------------------------------
    // eventHandler - 画像ファイルのダイアログ非表示
	//-----------------------------------------------
    const handleClick_dialog_imageFile_close = () => {
        setOpenDialogImageFile(false);
    };
	//-----------------------------------------------
    // eventHandler - PDF出力ボタンのクリック
	//-----------------------------------------------
    const handliClick_pdfExecute = () => {
        generateDailyReportPDF({
            entryDate,
            userName,
            "haccpMasta": haccpList,
            "dairyData" : searchEntryDateHygieneList_res,
            "checkData" : searchDataHistory_res,
            userList,
        })
    }
    //-----------------------------------------------
    // eventHandler - 取得ボタンのクリック
    //-----------------------------------------------
    const handleClick_getSensorDataAndCheck = (haccpCode) => {
        const tankNo = haccpCode - SENSOR_CODES[0] + 1;
        //console.log(`tankNo=${tankNo}`);
        judgeWaterQualityData(tankNo);
    };

    //===============================================
    // Function
    //===============================================
    //-----------------------------------------------
    // Function - 画像追加（File保持）
    //-----------------------------------------------
    async function addImages(fileList) {
        
        const file = fileList[0];
        const ext = file.name.split('.').pop().toLowerCase();
        const safeName = `${Date.now()}.${ext}`;
        const charFromCode1 = String.fromCharCode(1);
        const newUserCodePrefix = `${facilityCode}${charFromCode1}${userId}${charFromCode1}`;
        const newFileName = newUserCodePrefix + safeName;

		const invalidCharRegex = /\uFFFD/; // ?の判定用
        if (invalidCharRegex.test(newFileName)) {
        } else {
            // Blobを使って同じ内容で新しいファイル名を持つFileオブジェクトを作成
            const newFile = new File([file], newFileName, {type: file.type});
            const arg = new FormData();
            arg.append('targetFile', newFile);
            const res = await postFile(arg);
			//if (detailCode  === null) return;
			const files = Array.from(fileList || []);
			if (files.length === 0) return;

            if (!res) return;

            // どのスロットが空いてるか探す
            const nextKey = [
                "imageFilePathx1",
                "imageFilePathx2",
                "imageFilePathx3",
                "imageFilePathx4",
                "imageFilePathx5",
            ].find(key => !targetData[key]);

            if (!nextKey) {
                alert("画像は最大5件までです");
                return;
            }

            // targetDataにセット
            setTargetData(prev => ({
                ...prev,
                [nextKey]: res
            }));
        }
    }
    //-----------------------------------------------
    // Function - 画像削除
    //-----------------------------------------------
    function removeImage(targetPath) {
        const keys = [
            "imageFilePathx1",
            "imageFilePathx2",
            "imageFilePathx3",
            "imageFilePathx4",
            "imageFilePathx5",
        ];

        setTargetData(prev => {
            const newData = { ...prev };

            for (const key of keys) {
                if (newData[key] === targetPath) {
                    newData[key] = "";
                    break;
                }
            }

            return newData;
        });
    }
	//-----------------------------------------------
	// Function - ユーザー名を取得する
	//-----------------------------------------------
    function getUserName(targetUsetId){
        return userList?.find(userItem => String(userItem.userId) === String(targetUsetId))?.name;
    }
   	//-----------------------------------------------
	// Function - ステータス取得
	//-----------------------------------------------
    /**
     * @param {*} code コード
     * @param {*} value 入力値
     * @param {*} status ステータス
     * @returns 0:× 1:○
     */
    const getStatus = (code, value, status) => {
        const numValue = Number(value);
        const codeNum = Number(code);
        const isREFRIGERATORCode = REFRIGERATOR_CODES.includes(codeNum);
        const isFREEZERCode = FREEZER_CODES.includes(codeNum);

        if ((!isREFRIGERATORCode && !isFREEZERCode) || Number.isNaN(numValue) || value === "") {
            return status;
        }

        if (isFREEZERCode) {
            return numValue <= FREEZER_MAX_TEMPERATURE ? 1 : 0;
        }else{
            return (REFRIGERATOR_MIN_TEMPERATURE <= numValue && numValue <= REFRIGERATOR_MAX_TEMPERATURE) ? 1 : 0;
        }

    }
    //-----------------------------------------------
	// Function - データ登録後の表示データ取得
	//-----------------------------------------------
    const refreshData =(hygieneId) => {
        searchEntryDateHygieneList();
        setHygieneId(hygieneId);
        searchDataHistory();
    }
    //-----------------------------------------------
	// Function - データ登録・更新・削除後のメッセージ表示
	//-----------------------------------------------
    const onSuccess =() => {
        setOpenDialogCheclList(false);
        setOpenDialogDatail(false);
        setMessageInfo('confirm', false);
        setMessageInfo('confirm_detail', false);
        setMessageInfo('snackBarTrue', true);
    }

	//===============================================
	// UI Message - スナックバーのメッセージ設定
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'690px', color:'#fff', backgroundColor:'#808080'
    };

    const userList = searchData_res?.Data ?? [];
    const hygieneHistory = searchDataHistory_res?.Data ?? [];
    //===============================================
    // JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/hygineList" setEntryDate={handleChange_entryDate} />
            <div className='hygieneCheckList bodyContens'>
                <TitleBar title="高度衛生管理データ入力" color="#d66a35" />
                <div className='mainContents'>
                    <Frame classname="frame" title="HACCPチェックリスト" color="#d66a35">
                        <Box sx={{ display: 'flex', justifyContent: 'space-between',  }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                    color     = "primary"
                                    style     = {{color:'#fff', width: '130px' }}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<ChecklistIcon />}
                                    onClick   = { () => handleClick_dialog_checkList() }
                                >{'チェックリスト'}
                                </Button>
                                <ReaOnlyOutlinedInput
                                    type     = "text"
                                    id       = "hygieneCheckList_updateDatetimeDsps"
                                    label    = "最終入力時刻"
                                    value    = { hygieneData.updateDatetimeDsp }
                                    width    = "130px"
                                />
                                <ReaOnlyOutlinedInput
                                    type     = "text"
                                    id       = "hygieneCheckList_updateUser"
                                    label    = "最終入力者"
                                    value    = { hygieneData.updateUser }
                                    width    = "180px"
                                />
                                <CustomOutlinedInput
                                    type     = "text"
                                    id       = "hygieneCheckList_approvedUser"
                                    label    = "承認者"
                                    value    = { hygieneData.approvedUser }
                                    width    = "180px"
                                />
                                <Button
                                    color="secondary"
                                    size="midium"
                                    variant="contained"
                                    sx={{ marginLeft: '0px', color: '#fff', width: '120px' }}
                                    onClick={() => handliClick_pdfExecute()}
                                    startIcon={<PrintIcon />}
                                >{'PDF出力'}
                                </Button>
                            </Box>
                            <Box>
                                {
                                authority === 1 ?
                                <Button
                                    color="hygiene"
                                    size="midium"
                                   variant="contained"
                                    sx={{ marginLeft: '0px', color: '#fff', backgroundColor: '#d66a35', width: '120px' }}
                                    onClick = { () => setMessageInfo('confirm_apploved', true) }
                                    startIcon={<DoneAllIcon />}
                                >{'承認'} 
                                </Button>
                                :
                                <></>

                                }
                            </Box>
                        </Box>
                    </Frame>
                    <Frame classname="frame" title="当日の入力詳細" color="#d66a35">
                        <div style={{ height: contentsHeight, overflowY: "auto", }}>
                            {
                                haccpList.map((item, index) => (
                                <>
                                    <TitleBar title={item.name} color="#222B35" />
                                    <Box sx={{display:"flex", justifyContent: 'space-between'}} gap={2} style={{marginTop:'10px'}}>
                                        <Box sx={{ display: 'flex',  mt: 0 , gap: 1 }}>
                                            <div style={{marginLeft:'10px', marginTop:'4px', fontWeight:'bold'}}>{item.text}</div>
                                        </Box>
                                        <Box sx={{ display: 'flex',  mt: 0 , gap: 1 }}>
                                            {
                                                SENSOR_CODES.includes(item.code) ?
                                                <Button
                                                    color="primary"
                                                    size="small"
                                                    variant="contained"
                                                    sx={{ marginLeft: '10px', color: '#fff', width: '80px' }}
                                                    onClick={() => handleClick_getSensorDataAndCheck(item.code)}
                                                    startIcon={<GetAppIcon />}
                                                >{'取得'} 
                                                </Button>
                                                :
                                                <></>
                                            }
                                            <Button
                                                color="primary"
                                                size="small"
                                                variant="contained"
                                                sx={{ color: '#fff', width: '80px' }}
                                                onClick={() => handleClick_openDetailWithoutCheck(item.code, false, null)}
                                                startIcon={<AddCircleIcon />}
                                            >{'追加'}
                                            </Button>
                                            <Button onClick={() => handleScrollNext(index)} variant='outlined' color="error" style={{ visibility: index !== haccpList.length - 1 ? "visible" : "hidden" }}>↓</Button>
                                        </Box>
                                    </Box>
                                    <Stack spacing={2}>
                                        <TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'1em', marginBottom:'1em', /*maxHeight: 150, overflowY: 'auto'*/ }}>
                                            <Table stickyHeader sx={{ minWidth: '500px', padding:2, tableLayout:'fixed' }} size="small">
                                                <TableHead sx={{backgroundColor:'#222B35'}}>
                                                    <TableRow ref={(el) => (rowRefs.current[item.code] = el)}>
                                                        <TableCell style={{ width: 60,borderLeft:'1px solid #fff', backgroundColor:'#d66a35', color:'#fff' }} align="center">入力時刻</TableCell>
                                                        <TableCell style={{ width: 60,borderLeft:'1px solid #fff', backgroundColor:'#d66a35', color:'#fff' }} align="center">結果</TableCell>
                                                        <TableCell style={{ width: 400,borderLeft:'1px solid #fff', backgroundColor:'#d66a35', color:'#fff' }} align="center">記録内容</TableCell>
                                                        <TableCell style={{ width: 60,borderLeft:'1px solid #fff', backgroundColor:'#d66a35', color:'#fff' }} align="center">入力者</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        hygieneHistory.map((historyItem) => (
                                                        <>
                                                        {
                                                             String(item.code) === String(historyItem.code) && (
                                                                <TableRow onClick={() => handleClick_openDetailWithoutCheck(item.code, false, historyItem)} sx={{ cursor: "pointer" }}>
                                                                    <TableCell sx={{backgroundColor:'#fff', borderRight:'1px solid #eaeaea'}}align="center">{historyItem?.updateDatetime.substr(8, 2)}:{historyItem?.updateDatetime.substr(10, 2)}</TableCell>
                                                                    <TableCell sx={{backgroundColor:'#fff', borderRight:'1px solid #eaeaea'}}align="center">{String(historyItem?.checkStatus) === "1" ? "〇" : "✕"}</TableCell>
                                                                    <TableCell sx={{backgroundColor:'#fff', borderRight:'1px solid #eaeaea'}}align="left">{historyItem?.textx1}</TableCell>
                                                                    <TableCell sx={{backgroundColor:'#fff'}}align="center">{getUserName(historyItem.updateUserId)}</TableCell>
                                                                </TableRow>
                                                            )
                                                        }
                                                    </>))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Stack>
                                </>
                            ))
                            }
                            <Box sx={{display:"flex", justifyContent: 'space-between'}} gap={2} style={{marginTop:'10px'}}>
                                <Box sx={{ display: 'flex',  mt: 0 , gap: 1 }}>
                                </Box>
                                <Box sx={{ display: 'flex',  mt: 0 , gap: 1 }}>
                                    <Button onClick={() => handleScrollPrev(1)} variant='outlined' color="error">↑</Button>
                                </Box>
                            </Box>
                        </div>
                    </Frame>
                </div>
            </div>
            {/* チェックリストダイアログ */}
            <Dialog open={openDialogCheclList} onClose={handleClick_dialog_checkList_close} maxWidth="lg">
                <DialogTitle>
                    <TitleBar title="チェックリスト入力" color="#d66a35" />
                    <Box sx={{ display: 'flex',  mt: 2 , gap: 1 }}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <ReaOnlyOutlinedInput
                                type     = "text"
                                id       = "hygieneCheckList_updateUser"
                                label    = "最終入力時刻"
                                value    = { hygieneData.updateDatetimeDsp }
                                width    = "130px"
                            />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <ReaOnlyOutlinedInput
                                type     = "text"
                                id       = "hygieneCheckList_updateUser"
                                label    = "最終入力者"
                                value    = { hygieneData.updateUser }
                                width    = "180px"
                            />
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <Stack spacing={2}>
                        <TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'0em', marginBottom:'1em', /*maxHeight: 150, overflowY: 'auto'*/ }}>
                            <Table stickyHeader sx={{ minWidth: '1000px', padding:2 }} size="small">
                                <TableHead sx={{backgroundColor:'#222B35'}}>
                                    <TableRow>
                                        <TableCell style={{ width: '200px',borderLeft:'1px solid #fff', backgroundColor:'#222B35', color:'#fff' }} align="center">項目</TableCell>
                                        <TableCell style={{ width: '450px',borderLeft:'1px solid #fff', backgroundColor:'#222B35', color:'#fff' }} align="center">管理基準</TableCell>
                                        <TableCell style={{ width: '70px',borderLeft:'1px solid #fff', backgroundColor:'#222B35', color:'#fff' }} align="center">チェック結果</TableCell>
                                        <TableCell style={{ width: '90px',borderLeft:'1px solid #fff', backgroundColor:'#222B35', color:'#fff' }} align="center">記録内容</TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    targetDataList.map(item => {
                                        return (
                                            <TableBody key={item.code}>
                                                <TableRow>
                                                    <TableCell onClick={() => handleClick_openDetailWithoutCheck(item.code, true, null)} 
                                                        sx={{backgroundColor:'#fff', borderRight:'1px solid #eaeaea', cursor: "pointer"}}align="left">{item.name}</TableCell>
                                                    <TableCell onClick={() => handleClick_openDetailWithoutCheck(item.code, true, null)} 
                                                     sx={{backgroundColor:'#fff', borderRight:'1px solid #eaeaea', cursor: "pointer"}}align="left">{item.text}</TableCell>
                                                    <TableCell sx={{backgroundColor:'#fff', borderRight:'1px solid #eaeaea'}}align="left">
                                                        <CheckStatusButtons
                                                            value={item?.checkStatus ?? null}
                                                            onChange={(checkStatus) =>
                                                                handleChange_reportCheck(item, checkStatus)
                                                            }
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{backgroundColor:'#fff', borderRight:'1px solid #eaeaea'}}align="left">
                                                        <CustomOutlinedInput
                                                            type     = "text"
                                                            id       = "hygieneCheckList_approvedUser"
                                                            label    = ""
                                                            onChange = { (e) => handleChange_textx1(item.code, e.target.value)}
                                                            value    = { item.textx1 }
                                                            width    = "80px"
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        );
                                    })
                                }
                            </Table>
                        </TableContainer>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Stack spacing={2}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt:1 }}>
                            <Button
                                color     = "attention"
                                size      = "large"
                                variant   = "contained"
                                sx        = {{width:'240px', color:'#fff'}}
                                onClick = { () => setMessageInfo('confirm', true) }
                                startIcon = {<BackspaceIcon />}
                            >{'削除'}
                            </Button>
                            <Button
                                color     = "primary"
                                size      = "large"
                                variant   = "contained"
                                sx        = {{width:'240px', marginLeft:'10px'}}
                                onClick   = { () => handleClick_Register(1) }
                                startIcon = {<DoneIcon />}
                            >{'登録'}
                            </Button>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt:1 }}>
                            <Button
                                color="tertiary"
                                size="large"
                                variant="contained"
                                sx={dialog_button_close}
                                style={{ width: '500px', margin: "0 auto", marginBottom: '2%' }}
                                onClick={() => handleClick_dialog_checkList_close()}
                                startIcon={<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </Box>
                    </Stack>
                </DialogActions>
            </Dialog>
            {/* 詳細ダイアログ */}
            <Dialog open={openDialogDatail} onClose={handleClick_dialog_detail_close} fullWidth maxWidth="sm">
                <DialogTitle>
                    <TitleBar title={targetData.name} color="#d66a35" />
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}
                    >管理基準：  {targetData.text}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 1 }} >
                        <ReaOnlyOutlinedInput
                            id       = "originalFishSpecList_displayName"
                            label    = "入力日時"
                            value    = { targetData.updateDatetimeDsp }
                            width    = "130px"
                        />
                        <ReaOnlyOutlinedInput
                            id    = "originalFishSpecList_nameKana"
                            label = "入力者"
                            value    = { targetData.updateUser }
                            width = "180px"
                        />
                        <CheckStatusButtons
                            value={targetData.checkStatus}
                            width='100px'
                            onChange={(checkStatus) =>
                                handleChange_DatailScreenChangeCheckStatus(checkStatus)
                            }
                        />
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <Stack spacing={2}>
                        <CustomTextarea
                            id       = "haccpList_text"
                            label    = "記録内容・是正措置"
                            value    = { targetData.textx1 }
                            minRows    = "5"
                            color    = "hygiene"
                            onChange = { (e) => handleChange_DatailScreenTextx1(e.target.value)}
                        />
                        <Button component="label" variant="outlined">
                            画像を追加
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                multiple
                                onChange={(e) => addImages(e.target.files)}
                            />
                        </Button>
                        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
                            {[
                                targetData.imageFilePathx1,
                                targetData.imageFilePathx2,
                                targetData.imageFilePathx3,
                                targetData.imageFilePathx4,
                                targetData.imageFilePathx5,
                            ]
                                .filter(Boolean)
                                .map((path, i) => (
                                    <Box key={i} sx={{ position: "relative" }}>
                                        <Box
                                            component="img"
                                            src={`${fileURL}${path}`}
                                            alt={path}
                                            onClick={() => handleClick_dialog_imageFile(`${fileURL}${path}`)}
                                            sx={{
                                                width: 96,
                                                height: 96,
                                                objectFit: "cover",
                                                borderRadius: 1,
                                                border: "1px solid",
                                                borderColor: "divider",
                                            }}
                                        />
                                        <Button
                                            size="small"
                                            variant="contained"
                                            color="error"
                                            onClick={() => removeImage(`${path}`)}
                                            sx={{
                                                position: "absolute",
                                                top: 4,
                                                right: 4,
                                                minWidth: 0,
                                                px: 1,
                                                py: 0.2,
                                                lineHeight: 1,
                                            }}
                                        >
                                            削除
                                        </Button>
                                    </Box>
                                ))}
                        </Stack>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Stack spacing={2}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt:1 }}>
                            <Button
                                color     = "attention"
                                size      = "large"
                                variant   = "contained"
                                sx        = {{width:'240px', color:'#fff', visibility: isDispDeleteInDatail ? "visible" : "hidden"}}
                                onClick = { () => setMessageInfo('confirm_detail', true) }
                                startIcon = {<BackspaceIcon />}
                            >{'削除'}
                            </Button>
                            <Button
                                color     = "primary"
                                size      = "large"
                                variant   = "contained"
                                sx        = {{width:'240px', marginLeft:'10px'}}
                                onClick   = { () => handleClick_detailRegister(1) }
                                startIcon = {<DoneIcon />}
                            >{'登録'}
                            </Button>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt:1 }}>
                            <Button
                                color="tertiary"
                                size="large"
                                variant="contained"
                                sx={dialog_button_close}
                                style={{ width: '500px', margin: "0 auto", marginBottom: '2%' }}
                                onClick={() => handleClick_dialog_detail_close()}
                                startIcon={<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </Box>
                    </Stack>
                </DialogActions>
            </Dialog>
            {/* 画像ビューアダイアログ */}
            <Dialog open={ openDialogImageFile } onClose={ handleClick_dialog_imageFile } maxWidth="md" fullWidth>
                <DialogTitle>
                    <TitleBar title="画像を確認" />
                </DialogTitle>
                <DialogContent dividers>
                    <Box
                        component="img"
                        src={`${openDialogImageFile}`}
                        alt={openDialogImageFile}
                        sx={{
                            width: "100%",
                            height: "auto",
                            maxHeight: "70vh",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        color     = "tertiary"
                        size      = "large"
                        variant   = "contained"
                        sx        = { dialog_button_close }
                        style = {{width:'500px', margin: "0 auto", marginBottom:'2%'}}
                        onClick   = {() => handleClick_dialog_imageFile_close()}
                        startIcon = {<CloseIcon />}
                    >{'閉じる'}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* UIメッセージ */}
            <CustomSnackBar
                open={messageState.snackBarTrue}
                onClose={() => setMessageInfo('snackBarTrue', false)}
                severity="success"
                backgroundColor="#2e8b57"
                message="登録しました"
            />
            <CustomSnackBar
                open            = {messageState.snackBarFalse}
                onClose         = {() => setMessageInfo('snackBarFalse', false)}
                severity        = "error"
                backgroundColor = "#db7093"
                message         = "登録に失敗しました"
            />
            <CustomSnackBar
                open={messageState.require}
                onClose={() => setMessageInfo('require', false)}
                severity="error"
                backgroundColor="#db7093"
                message={requireMessage}
            />
            <CustomConfirm
                open      = {messageState.confirm}
                onClose   = {() => setMessageInfo('confirm', false)}
                onClickNG = {() => setMessageInfo('confirm', false)}
                onClickOK = {() => handleClick_Register(0)}
                message   = "入力データの削除を行います。よろしいですか？"
            />
            <CustomConfirm
                open      = {messageState.confirm_detail}
                onClose   = {() => setMessageInfo('confirm_detail', false)}
                onClickNG = {() => setMessageInfo('confirm_detail', false)}
                onClickOK = {() => handleClick_detailRegister(0)}
                message   = "履歴の削除を行います。よろしいですか？"
            />
            <CustomConfirm
                open      = {messageState.confirm_apploved}
                onClose   = {() => setMessageInfo('confirm_apploved', false)}
                onClickNG = {() => setMessageInfo('confirm_apploved', false)}
                onClickOK = {() => handleClick_applovedRegister(9)}
                message   = "本日入力データの承認を行います。よろしいですか？"
            />
            <CustomSnackBar
                open            = {messageState.resultSelectionAlert}
                onClose         = {() => setMessageInfo('resultSelectionAlert', false)}
                severity        = "error"
                backgroundColor = "#db7093"
                message         = {
                                     <span style={{ whiteSpace: 'pre-line' }}>
                                        {"いずれの項目も結果が選択されていません\n少なくとも1件は選択してください"}
                                     </span>
                                  }
            />
            <CustomSnackBar
                open            = {messageState.resultSelectionAlertInDetail}
                onClose         = {() => setMessageInfo('resultSelectionAlertInDetail', false)}
                severity        = "error"
                backgroundColor = "#db7093"
                message         = "結果が選択されていません。"
            />
        </>
    )
}
export default HygieneCheckList;
